import Navigation from './Navigation';
import wipLogo from '../imgs/wip-logo.svg'
import '../css/WIP.css'

function WIP({WebpageName}){
    return(
        <div className='wip'>
            <Navigation />
            <div className='wip-body'>
                <img src={wipLogo} className="wip-logo" alt="WIP" />
                <h1 className='stuff-header-text'>{WebpageName} is a work in progress</h1>
            </div>
      </div>
    )
}

export default WIP;